// extracted by mini-css-extract-plugin
export default {"sections__scroll-content_menu-closed":"sections__scroll-content_menu-closed__39irb"};